(function($) {

    $(".form-theme-picker").each(function () {
        const theme = $(this).data("theme");
        $(this).closest(".EPiServerForms").addClass("theme theme-" + theme);
    });


})(jQuery);